module.exports = __webpack_public_path__ + "media/icons/file-csv-0b3e5c53.png";